import { isReactNativeApp, isNativeAppMajorVersionBelow } from '@mobi/web-native-comms/web'
import { NativeAppVersionWithRemovedTabNav } from './constants'

export const shouldApplySafeAreaBottomPadding =
  (isReactNativeApp && !isNativeAppMajorVersionBelow(NativeAppVersionWithRemovedTabNav)) ||
  !isReactNativeApp
